// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".setUp[data-v-0d2d59a5] .ivu-tabs-nav-scroll {\n  padding: 0 30px;\n}\n.setUp[data-v-0d2d59a5] .ivu-tabs-nav .ivu-tabs-tab {\n  padding: 8px 45px;\n}", ""]);
// Exports
module.exports = exports;
